import {ValHabilitationsCacheService} from "../../../val-ammon-permissions/val-permissions-lib/src/public-api";
import {ValConstantesCacheService} from "../../../val-ammon-services/val-services-communs-lib/src/public-api";
import {ValGestionFichesEditionService} from "../../../val-fiches-edition/val-fiches-edition-lib/src/public-api";

//Représente les services communs
export class ValServicesCommuns 
{
  //Gestion des fiches d’édition
	public get GestionFichesEdition () : ValGestionFichesEditionService 
	{
		return this.valGestionFichesEditionService;
	}

  //Gestion des fiches d’édition
	public set GestionFichesEdition (valGestionFichesEditionService: ValGestionFichesEditionService) 
	{
		this.valGestionFichesEditionService = valGestionFichesEditionService;
	}

  //Gestion des fiches d’édition
	private valGestionFichesEditionService!: ValGestionFichesEditionService;

	//Habilitations
	public get Habilitations () : ValHabilitationsCacheService 
	{
		return this.valHabilitationsCacheService;
	}

	//Habilitations
	public set Habilitations (valHabilitationsCacheService: ValHabilitationsCacheService) 
	{
		this.valHabilitationsCacheService = valHabilitationsCacheService;
	}

	//Habilitations
	private valHabilitationsCacheService!: ValHabilitationsCacheService;

	//Constantes
	public get Constantes () : ValConstantesCacheService 
	{
		return this.valConstantesCacheService;
	}

	//Constantes
	public set Constantes (valConstantesCacheService: ValConstantesCacheService) 
	{
		this.valConstantesCacheService = valConstantesCacheService;
	}

	//Constantes
	private valConstantesCacheService!: ValConstantesCacheService;
}

export const ServicesCommuns: ValServicesCommuns = new ValServicesCommuns ();